import React, { useEffect, useState } from "react";
import { MapPage } from "../components/mapping/map/MapPage";
import { PageContentDict, globalDB } from "../store/globalStore";
import { PageContext } from "../context/PageContext";
import { useLiveQuery } from "dexie-react-hooks";
import { setUserIP } from "../utils/helpers";

export async function getStaticProps() {
  const res = await fetch(
    "https://dme-staging-1f15eaad7fd6.herokuapp.com/api/page_text/en",
  );
  const pageContent = await res.json();
  return {
    props: {
      pageContent,
    },
  };
}

export default function Map({ pageContent }) {
  const [languageSpecificContent, setLanguageSpecificContent] =
    useState<PageContentDict>();
  const content = languageSpecificContent?.data ?? pageContent.data;
  const selectedLanguage = useLiveQuery(() => globalDB.language.toArray());

  useEffect(() => {
    setUserIP();
  }, []);

  useEffect(() => {
    if (selectedLanguage && selectedLanguage[0] && globalDB.pageContent) {
      globalDB.pageContent
        .where("lang")
        .equals(selectedLanguage[0].iso_code)
        .toArray()
        .then((res) => {
          setLanguageSpecificContent(res[0].page_content);
        });
    }
  }, [selectedLanguage]);

  return (
    <PageContext.Provider value={content}>
      <MapPage />
    </PageContext.Provider>
  );
}
